import BtnProgress from './component/BtnProgress';
import BtnCheck from './component/BtnCheck';
import Animation from './component/Animation';
import { Form } from './component/Form';
import FlashMessage from './component/FlashMessage';
import ToggleShow from './component/ToggleShow';
import Navbar from './component/Navbar';
import Modal from './component/Modal';
import Anchor from './component/Anchor';
import VideoItem from './component/VideoItem';
import MerchEmbed from './component/MerchEmbed';
import Ga4Tracking from './component/Ga4Tracking';
import NetteForms from 'nette-forms';

document.addEventListener('DOMContentLoaded', _naja.initialize.bind(_naja));
NetteForms.initOnLoad();
(<any>window).nette = NetteForms;

window.addEventListener('DOMContentLoaded', () => {
    BtnProgress.init();
    BtnCheck.init();
    Animation.init();
    Form.init();
    FlashMessage.init();
    ToggleShow.init();
    Navbar.init();
    Modal.init();
    Anchor.init();
    Ga4Tracking.init();
    VideoItem.init();
    MerchEmbed.init();
});

window.addEventListener('scroll', () => {
    Animation.init();
});
